/**
 * Google Analytics 4 (gtag.js)
 *
 * The measurement ID comes from the connected Google Analytics account
 * (VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY) so the site reports
 * directly to GA4 instead of depending on the Tag Manager container.
 */

export const GA_MEASUREMENT_ID = import.meta.env
  .VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY as string | undefined;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  if (!GA_MEASUREMENT_ID) return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  const gtag = (...args: unknown[]) => {
    // gtag requires the raw arguments object shape on dataLayer.
    window.dataLayer.push(args as unknown as Record<string, unknown>);
  };
  window.gtag = gtag;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  // The Tag Manager container already fires the first page_view for this
  // stream, so this config stays silent and only SPA route changes are sent
  // below. That keeps one page_view per page instead of two.
  gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path: string, title?: string) {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title ?? document.title,
    page_location: window.location.href,
  });
}
